

export const downloadOriginalPDF = async (response: any, downloadFileName: string) => {
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const file = new Blob([bom, response], {
      type: 'application/pdf',
    });
    saveAs(file, downloadFileName);
  };